export default __webpack_public_path__ + "static/tripadvisor_dark-1df07a6043b151f8fc459ffad23cbb65.svg";